import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_PhotoRestoration = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/photo-restoration',
			name: 'Old Photo Restoration AI',
			description:
				'Restore old photos to vibrant memories in seconds. Online AI photo restoration tool, no watermarks.',
			url: 'https://liftapp.ai/photo-restoration',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/photo-restoration#product' },
				{ '@id': 'https://liftapp.ai/photo-restoration#howto' },
				{ '@id': 'https://liftapp.ai/photo-restoration#benefits' },
				{ '@id': 'https://liftapp.ai/photo-restoration#faq' },
				{ '@id': 'https://liftapp.ai/photo-restoration#why-lift' },
				{ '@id': 'https://liftapp.ai/photo-restoration#explore-tools' },
				{ '@id': 'https://liftapp.ai/photo-restoration#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/photo-restoration#product',
			name: 'Old Photo Restoration AI',
			description:
				'Restore old photos to vibrant memories in seconds. Online AI photo restoration tool, no watermarks.',
			url: 'https://liftapp.ai/photo-restoration',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/photo-restoration#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Apply AI restoration',
					text: "Let Lift's AI remove scratches, fix tears, enhance faded colors, and sharpen blurry details",
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-restoration#benefits',
			name: 'Who can benefit from AI Photo Restoration?',
			description:
				'Lift AI Photo Restoration helps e-commerce sellers, content creators, marketers, and more improve image quality instantly with AI retouching.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'AI Photo Restoration is perfect for anyone wanting to preserve precious memories',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Families can restore old photos of grandparents, weddings, and childhood moments to share across generations',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Photographers can restore vintage client photos and offer restoration services to their customers',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Social media users can share restored family photos that get more engagement and emotional connection',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'AI Photo Restoration bridges the gap between damaged memories and crystal-clear keepsakes, making it essential for preserving your visual history',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/Landing_2.55577bff.webp',
				name: '',
				description: '',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/photo-restoration#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Photo Restorer?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Photo Restorer is a premium online tool that improves photo clarity, colour and resolution up to 4K in a single click.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Photo Restoration work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'AI photo restoration quality uses a two-step deep-learning process: first, a smart denoiser cleans blur and noise; next, a super-resolution model rebuilds lost pixels, boosts colours and sharpens edges all the way up to crisp 4K. Everything runs in the cloud, so you get pro-level photo quality with one click.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can it restore severely damaged or faded photos?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI Photo Restorer is trained to handle various types of damage including deep scratches, torn sections, water stains, severe fading, and color shifts. It intelligently reconstructs missing areas and revives colors to make old photos look new again.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-restoration#why-lift',
			name: "Why Lift's AI photo restoration stands out",
			description:
				"Lift's AI photo restoration provides professional results, AI accuracy, cross-platform support, and is budget-friendly.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/Landing_3.5ac96b44.webp',
				name: '',
				description: '',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-extender#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/photo-restoration#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Photo Restoration',
					item: 'https://liftapp.ai/photo-restoration',
				},
			],
		},
	],
};
